import { Box, useMediaQuery } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Footer from "../footer/Footer";
import CartNavbar from "../navbar/CartNavbar";
import Navbar from "../navbar/Navbar";

export default function CartLayout() {
  const [mobile] = useMediaQuery("(max-width: 600px)");
  return (
    <div>
      {!mobile ? <Navbar /> : <CartNavbar />}
      <Outlet />
    </div>
  );
}
